<mat-card>
  <mat-card-header>
    <mat-card-title>{{ 'title.approved_contract_moha'| translate}}</mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'enterprise_contract.ttl_search' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #myForm="ngForm" (ngSubmit)="onFilterData(0, paginate.pageSize)" class="pb-3">
          <div class="row">

            <!-- UUID Hợp đồng -->
      <div class="col-md-3 col-lg-4">
        <mat-form-field class="w-100">
          <input type="text" 
          (focusout)="documents.idMoha = documents.idMoha == undefined ? '' : (documents.idMoha + '').trim()"
          matInput [placeholder]="'search_form.uuid_contract' | translate" [(ngModel)]="documents.idMoha"
            name="idMoha" maxlength="50"
            autocomplete="off">
        <button mat-button *ngIf="documents.idMoha" type="button" matSuffix mat-icon-button
         aria-label="Clear" (click)="clearInputUUID()">
        <mat-icon>close</mat-icon>
       </button>
         </mat-form-field>
    </div>

            <!-- Tên/Mã tài liệu -->
            <div class="col-lg-4 col-md-6">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.nameOrCode = documents.nameOrCode == undefined ? '' : (documents.nameOrCode + '').trim()"
                       #focusInput matInput [placeholder]="'search_form.doc_name_or_code' | translate" name="nameOrCode"
                       [(ngModel)]="documents.nameOrCode" maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.nameOrCode" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.nameOrCode=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Email/tên khách hàng -->
            <div class="col-lg-4 col-md-6">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.customer = documents.customer == undefined ? '' : (documents.customer + '').trim()"
                       matInput [placeholder]="'search_form.custommer_name_or_email' | translate" name="customer"
                       [(ngModel)]="documents.customer" maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.customer" type="button" matSuffix mat-icon-button aria-label="Clear"
                        (click)="documents.customer=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <!-- Trạng thái -->
            <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <mat-label>{{'headertable.status_process' | translate}}</mat-label>
                <mat-select #statusSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                            (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="status" name="status"
                            [(ngModel)]="documents.status" (ngModelChange)="onSearch(0, paginate.pageSize)">
                  <mat-option [value]="''" selected (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'form.select_all' | translate}}</mat-option>
                  <mat-option [value]="contractUserStatus.PROCESSING"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.contract_user_status_sign_no_process' | translate}}</mat-option>
                  <mat-option [value]="contractUserStatus.PROCESSED"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.contract_user_status_sign_process' | translate}}</mat-option>
                  <mat-option [value]="contractUserStatus.REJECTED"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.contract_user_status_rejected' | translate}}</mat-option>
                  <mat-option [value]="contractUserStatus.NO_PROCESS"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.contract_user_status_stop_process' | translate}}</mat-option>
                  <mat-option [value]="contractUserStatus.DAEMON_PROCESSING"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.contract_user_status_sign_daemon_process' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Tên của người chuyển -->
            <div class="col-md-6 col-lg-4" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.createdUser = documents.createdUser == undefined ? '' : (documents.createdUser + '').trim()"
                       matInput [placeholder]="'search_form.forward_by' | translate" name="createdUser"
                       [(ngModel)]="documents.createdUser" maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.createdUser" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.createdUser=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Thời gian nhận (từ ngày) -->
            <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <mat-label>{{ 'search_form.received_date_from' | translate }}</mat-label>
                <input matInput [matDatepicker]="receivedTimeFrom" #receivedTimeFromCtrl="ngModel"
                       (focus)="receivedDateErr = 'fromDate'"
                       (change)="this.commonService.resetDatePicker(pickerInput.value, this.ngForm.controls['receivedTimeFrom'])"
                       name="receivedTimeFrom" #pickerInput [(ngModel)]="documents.receivedTimeFrom" maxlength="200"
                       [max]="documents.receivedTimeTo" autocomplete="off"/>
                <mat-datepicker-toggle matSuffix [for]="receivedTimeFrom">
                  <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                     [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                </mat-datepicker-toggle>
                <mat-datepicker #receivedTimeFrom></mat-datepicker>
                <mat-error *ngIf="receivedTimeFromCtrl?.errors?.matDatepickerParse">
                  {{'validation.format_of_date' | translate}}
                </mat-error>
                <mat-error *ngIf="receivedTimeFromCtrl?.errors?.matDatepickerMax && receivedDateErr == 'fromDate'">
                  {{ 'search_form.received_date_from' | translate }}
                  {{ 'validation.from_date_smaller_than_or_equal_to_date' | translate }}
                  {{ 'search_form.received_date_to' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Thời gian nhận (đến ngày) -->
            <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <mat-label>{{ 'search_form.received_date_to' | translate }}</mat-label>
                <input matInput [matDatepicker]="receivedTimeToRef" [min]="documents.receivedTimeFrom"
                       (focus)="receivedDateErr = 'toDate'"
                       (change)="this.commonService.resetDatePicker(pickerInput1.value, this.ngForm.controls['receivedTimeTo'])"
                       name="receivedTimeTo" #pickerInput1 [(ngModel)]="documents.receivedTimeTo"
                       #receivedTimeToCtrl="ngModel" maxlength="200" autocomplete="off"/>
                <mat-datepicker-toggle matSuffix [for]="receivedTimeToRef">
                  <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                     [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                </mat-datepicker-toggle>
                <mat-datepicker #receivedTimeToRef></mat-datepicker>
                <mat-error *ngIf="receivedTimeToCtrl?.errors?.matDatepickerParse">
                  {{'validation.format_of_date' | translate}}
                </mat-error>
                <mat-error *ngIf="receivedTimeToCtrl?.errors?.matDatepickerMin && receivedDateErr == 'toDate'">
                  {{ 'search_form.received_date_to' | translate }}
                  {{ 'validation.to_date_larger_than_or_equal_from_date' | translate }}
                  {{ 'search_form.received_date_from' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Loại hợp đồng -->
            <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <mat-label>{{'form.service_type' | translate}}</mat-label>
                <mat-select #serviceTypeSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                            (focus)="commonService.openComboBox(checkFocus, serviceTypeSelect)" id="serviceType"
                            [disabled]="!myForm.valid" name="serviceType" [(ngModel)]="documents.type"
                            (ngModelChange)="onSearch(0, paginate.pageSize)">
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                           [placeholderLabel]="'search_form.search' | translate"
                                           [formControl]="serviceTypeByEnterpriseFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option value="null" selected
                              (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)">
                    {{'form.select_all' | translate}}
                  </mat-option>
                  <mat-option *ngFor="let serviceType of filteredServiceTypeByEnterprise | async" [value]="serviceType.id"
                              (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)">
                    {{serviceType.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- button up/down -->
            <div class="col-lg-12 col-md-6 d-flex justify-content-end">
              <button *ngIf="!isBasicSearchForm" type="button" mat-button class="advance-search"
                      (click)="onCloseAdvancedSearchForm()">
                <span>{{'enterprise_contract.buttons.basic' | translate}}</span>
                <em class="material-icons">keyboard_arrow_up</em>
              </button>
              <button *ngIf="isBasicSearchForm" type="button" mat-button class="advance-search"
                      (click)="onExpandAdvancedSearchForm()">
                <span>{{'enterprise_contract.buttons.advance' | translate}}</span>
                <em class="material-icons">keyboard_arrow_down</em>
              </button>
            </div>
          </div>

          <!-- button tìm kiếm -->
          <div class="row mt-3">
            <div class="col-lg-12 d-flex justify-content-center">
              <button mat-stroked-button color="primary" type="submit" (click)="onClickBtnFilter()" appTrackEvent="w.btn.hd_ky_duyet.tim_kiem"
                      [disabled]="!myForm.valid">
                <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                {{'enterprise_document_template.buttons.search' | translate}}
              </button>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title class="mat-panel-title mat-panel-title-sm mt-3 d-flex justify-content-between align-items-center list-title">
          <!-- Header title -->
          <div  class="title col-xs-12 pl-0">
            <span class="mt-4">{{'enterprise_contract.list_document_wait_sign' | translate}}
              ({{paginate.totalRow}}), {{'enterprise_contract.selected_title' | translate}}: {{dataSelected.length}}
            </span>
          </div>
          <!--  Button  -->
          <div class="d-flex buttonMD align-items-center list-title list-title-apru">
            <div class="list-btn" *ngIf="!isSigning; else showSigningBackground">
              <!-- Button -->
              <!-- <button class="mr-1 list-btn-1" mat-stroked-button color="primary" (click)="openSignSlot()" [disabled]="countCheck == 0 || this.dataSource == null || this.dataSource.data == null
              || this.dataSource.data.value == null
              || this.dataSource.data.value.length === 0" appTrackEvent="w.btn.hd_ky_duyet.ky_theo_lo">
                <mat-icon class="mr-0">gesture</mat-icon>
                {{'button.sign_lot' | translate}}
              </button> -->
              <!-- Button -->
              <!-- <button class="button-sign-all " (click)="openSignAll()" [disabled]="this.dataSource == null
              || this.dataSource.data == null
              || this.dataSource.data.value == null
              || this.dataSource.data.value.length === 0
              || this.oldData.status === 3
              || this.oldData.status === 4
              || (this.oldData.status === null && this.waitSignDocsCount === 0)" mat-stroked-button color="primary" appTrackEvent="w.btn.hd_ky_duyet.ky_tat_ca_hd">
                <mat-icon class="mr-0">gesture</mat-icon>
                {{'button.sign_all' | translate}}
              </button> -->

              <button class="pull-right ml-1 list-btn " mat-stroked-button color="primary" type="button" appTrackEvent="w.btn.hd_ky_duyet.khac"
                      [matMenuTriggerFor]="menuFeature" >
                <mat-icon>apps</mat-icon>
                {{'button.more_feature' | translate}}
              </button>
            </div>

            <ng-template #showSigningBackground>
              <div layout-align="center center end-start">
                <div class="row">
                  <div class="col-11">
                    <span>{{'messages.signing_progress' | translate}} {{processedPercent}}%</span>
                    <mat-progress-bar mode="determinate" [value]="processedPercent" [bufferValue]="100">
                    </mat-progress-bar>
                  </div>
                  <div class="col-1" layout="row" layout-align="end center">
                    <button mat-icon-button color="primary" (click)="handleSingingProcess()" matTooltip="">
                      <mat-icon>gesture</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>

            <mat-menu #menuFeature="matMenu" >

              <button class="btn1-mine hideicon other-button" mat-menu-item   type="button" (click)=" $event.stopPropagation()"  [matMenuTriggerFor]="menuColumn"
                      *ngIf="!commonService.getIsLockedEnterprise()"
                      style="border-bottom: 1px solid rgb(213 213 213) !important;">
                <mat-icon class="mr-0 other-button" >more_vert</mat-icon>
                {{'bodytable.status_column' | translate}}
              </button>

              <button class="btn1-mine" appTrackEvent="w.btn.hd_ky_duyet.khac.tai_hd"
                      [ngClass]="{'other-button': this.dataSelected.length !== 0 }"
                      [disabled]=" this.dataSelected.length === 0" mat-menu-item class="other-button" (click)="multiDownload()">
                <mat-icon class="mr-0 "  [ngClass]="{'other-button': this.dataSelected.length !== 0 }">save_alt</mat-icon>
                {{'button.downloadContract' | translate}}
              </button>
            </mat-menu>

            <mat-menu #menuColumn="matMenu"  >
              <mat-checkbox style="margin: 0px 15px" [(ngModel)]="isCheckedAllColumn" (click)="$event.stopPropagation()" (change)="onAllColumnCheckboxChange(isCheckedAllColumn)"
              >{{ 'form.select_all_group' | translate}}</mat-checkbox>
              <div *ngFor="let option of columnDefinitions">
                <mat-checkbox style="margin: 0px 15px" [(ngModel)]="option.default" (change)="onCheckboxChange(option)" (click)="$event.stopPropagation()"
                              [checked]="option.default" *ngIf="!option.check"
                >{{ option.name | translate}}</mat-checkbox>
              </div>
            </mat-menu>

          </div>

        </mat-panel-title>

        <div class="mat-table-container" style=" display: block; max-height: 590px">
          <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" [ngStyle]="{'min-width': tableWidth + 'px'}">
            <!-- check -->
            <ng-container matColumnDef="check">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                <mat-checkbox [(ngModel)]="checkAll" (change)="checkAllDocument()" color="primary"></mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                        (click)="$event.stopPropagation()">
                <mat-checkbox color="primary" [(ngModel)]="element.checked" (change)="onSelectionChange()">
                </mat-checkbox>
              </mat-cell>
            </ng-container>

            <!-- STT -->
            <ng-container matColumnDef="STT">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_contract.table_headers.No' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                        (click)="$event.stopPropagation()">
                {{element.STT}}
              </mat-cell>
            </ng-container> 

            <!-- UUID Hợp đồng -->
            <ng-container matColumnDef="idMoha">
              <mat-header-cell *matHeaderCellDef style="max-width: 30%;"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.uuid_contract' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.idMoha }}"
                class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()" style="max-width: 30%;">
                <span class="fix-width">{{ element.idMoha }}</span>
              </mat-cell>
            </ng-container>

            <!-- Tài liệu Column -->
            <ng-container matColumnDef="contractName">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 20%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.document_code_name' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{element.name}}" (click)="$event.stopPropagation()"
                        class="mat-cell-non-boder-right-bottom" style="width: 20%;">
                <span class="fix-width">{{element.name}}</span>
              </mat-cell>
            </ng-container>

            <!-- Khách hàng Column -->
            <ng-container matColumnDef="allName">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.contract_parties' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.allName }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()">
                <span class="fix-width">{{ element.allName}}</span>
              </mat-cell>
            </ng-container>

            <!-- Email các bên ký hợp đồng Column -->
            <ng-container matColumnDef="allEmail">
              <mat-header-cell *matHeaderCellDef style="max-width: 20%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.contract_parties_email' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.allEmail }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                        style="max-width: 20%;">
                <span class="fix-width">{{ element.allEmail }}</span>
              </mat-cell>
            </ng-container>

            <!-- Trạng thái Column -->
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef class="doc-status-col mat-cell-non-boder-right-bottom"
                               style="max-width: 10%;">
                {{'form.status_process' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center"
                        style="max-width: 10%;"
                        (click)="$event.stopPropagation()">
                <nz-tag *ngIf="element.status === contractUserStatus.PROCESSING && element.cStatus === 2"
                        [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_sign_no_process' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status === contractUserStatus.PROCESSED" [nzColor]="'green'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_sign_process' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.status === contractUserStatus.REJECTED" [nzColor]="'red'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_rejected' | translate}}
                </nz-tag>
                <nz-tag
                  *ngIf="element.status === contractUserStatus.PROCESSING && (element.cStatus === 5 || element.cStatus === 3)"
                  style="margin-right: 0px;">{{'search_form.contract_user_status_stop_process' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.status === contractUserStatus.DAEMON_PROCESSING && element.cStatus === 2"
                        [nzColor]="'orange'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_sign_daemon_process' | translate}}</nz-tag>
              </mat-cell>
            </ng-container>

            <!-- người chuyển -->
            <ng-container matColumnDef="createdUser">
              <mat-header-cell *matHeaderCellDef style="max-width: 11%;" mat-sort-header
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                <span>
                  {{'enterprise_contract.table_headers.forward_by' | translate}}
                </span>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.createdUser }}"
                        (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom"
                        style="max-width: 11%;">
                <span class="fix-width">{{ element.createdUser }}</span>
              </mat-cell>
            </ng-container>

            <!-- Thời gian nhận Column -->
            <ng-container matColumnDef="receivedTime">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="max-width: 10%">
                {{'headertable.received_time' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                        [matTooltip]="element.receivedTime | dateformat"
                        (click)="$event.stopPropagation()" style="max-width: 10%">
                <span class="fix-width">{{ element.receivedTime | dateformat}}</span>
              </mat-cell>
            </ng-container>

            <!-- nguoi lap -->
            <ng-container matColumnDef="createdBy">
              <mat-header-cell *matHeaderCellDef style="max-width: 7%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise_contract.table_headers.created_by' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"  matTooltip="{{ element.createdBy }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                        style="max-width: 7%; justify-content: center;">
                <span class="fix-width">{{ element.createdBy }}</span>
              </mat-cell>
            </ng-container>

            <!-- Trạng thái kí kết khác  -->
            <ng-container matColumnDef="statusOther">
              <mat-header-cell *matHeaderCellDef style="max-width: 10%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.other_signing_parties_status' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center"
                        style="max-width: 10%;"
                        (click)="$event.stopPropagation()">
                <nz-tag *ngIf="element.statusOther === enumContractUserStatus.STOP_PROCESS.toString()" style="margin-right: 0px;">
                  {{'search_form.contract_user_status_stop_process' | translate}}</nz-tag>
                <nz-tag *ngIf="element.statusOther === enumContractUserStatus.NO_PROCESS.toString()" style="margin-right: 0px;">
                  {{'form.document_status_wait' | translate}}</nz-tag>
                <nz-tag *ngIf="element.statusOther === enumContractUserStatus.PROCESSING.toString()" [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'messages.sign_processing' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.statusOther === enumContractUserStatus.REJECTED.toString()" [nzColor]="'red'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_rejected' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.statusOther === enumContractUserStatus.PROCESSED.toString()" [nzColor]="'green'"
                        style="margin-right: 0px;">{{'form.document_status_signed' | translate}}</nz-tag>
                <nz-tag *ngIf="element.statusOther === enumContractUserStatus.CANCELLED" [nzColor]="'red'"
                        style="margin-right: 0px;">{{'search_form.cancelled' | translate}}</nz-tag>
                <nz-tag *ngIf="element.statusOther == enumContractUserStatus.DAEMON_PROCESSING.toString()" [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'search_form.connecting' | translate}}</nz-tag>
              </mat-cell>
            </ng-container>

            <!--Ngày hết hiệu lực Column -->
            <ng-container matColumnDef="expiredDate">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="max-width: 11%;">
                {{'enterprise-certificate_management.lbl_end_date' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                        [matTooltip]="element.expiredDate | dateformat"
                        (click)="$event.stopPropagation()" style="max-width: 11%;">
                <span class="fix-width">{{ element.expiredDate | dateformat}}</span>
              </mat-cell>
            </ng-container>

            <!-- Tác động Column -->
            <ng-container matColumnDef="action" class="mat-column-symbol ">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center action-col-3 mat-cell-non-border-bottom"
                               style="min-width: 100px">
                {{'headertable.action' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center action-col-3 mat-cell-non-border-bottom"
                        style="min-width: 100px" (click)="$event.stopPropagation()">
                <button mat-icon-button (click)="viewDetail(element)" appTrackEvent="w.btn.hd_ky_duyet.xem_chi_tiet"
                        matTooltip="{{'enterprise_contract.buttons.view' | translate}}">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button mat-icon-button (click)="openPDFByBrowser(element)" appTrackEvent="w.btn.hd_ky_duyet.tai">
                  <mat-icon matTooltip="{{'enterprise_contract.buttons.download' | translate}}">save_alt
                  </mat-icon>
                </button>

                
                <button mat-icon-button [matMenuTriggerFor]="menu" appTrackEvent="w.btn.hdtoilap.thaotackhac">
                  <mat-icon matTooltip="{{'enterprise_contract.buttons.more_icon' | translate}}">more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <!-- retry -->
                  <!-- <button mat-menu-item *ngIf="element.cecaReTry" (click)="retry(element.id)">
                    <mat-icon matTooltip="{{'enterprise_contract.buttons.retry' | translate}}" class="mr-1">
                      replay
                    </mat-icon>
                    <span class="fix-width">{{'enterprise_contract.buttons.retry' | translate}}</span>
                  </button> -->
                  <!-- Update tài liệu -->
                  <!-- <button mat-menu-item appTrackEvent="w.btn.hdtoilap.cap_nhat"
                    *ngIf="mediaBreakpoint !== SCREEN_SIZE.XXL && mediaBreakpoint !== SCREEN_SIZE.XL"
                    (click)="onUpdate(element)" [disabled]="element.status !== enumContractStatus.DRAFT">
                    <mat-icon class="mr-1" *ngIf="element.status == 1"
                      matTooltip="{{'enterprise_contract.buttons.edit' | translate}}">edit
                    </mat-icon>
                    <mat-icon class="mr-1" *ngIf="element.status !== enumContractStatus.DRAFT">edit
                    </mat-icon>
                    <span>{{'enterprise_contract.buttons.edit' | translate}}</span>
                  </button> -->
                  <!-- Sao chép tài liệu -->
                  <!-- <button *ngIf="checkPermissionCreateContract()" appTrackEvent="w.btn.hdtoilap.thaotackhac.sao_chep"
                    [disabled]="warningContractQuantity || element.formType === 'CONTRACT_APPENDIX'" mat-menu-item
                    (click)="copyDocument(element.id, element.typeId)"> -->
                    <!-- <mat-icon class="mr-1"
                              matTooltip="{{'enterprise_contract.buttons.copy' | translate}}">file_copy
                    </mat-icon> -->
                    <!-- <mat-icon class="mr-1">file_copy</mat-icon>
                    <span>{{'enterprise_contract.buttons.copy' | translate}}</span>
                  </button> -->
                  <!-- Xóa -->
                  <!-- <button mat-menu-item (click)="delete(element.id,'',element.name)"
                    appTrackEvent="w.btn.hdtoilap.thaotackhac.xoa"
                    [disabled]="element.status !== enumContractStatus.DRAFT">
                    <i *ngIf="element.status == enumContractStatus.DRAFT" class="fa fa-trash mr-1 p-1"
                      aria-hidden="true"
                      matTooltip="{{'enterprise_customer_management.buttons.delete' | translate}}"></i>
                    <i *ngIf="element.status !== enumContractStatus.DRAFT" class="fa fa-trash mr-1 p-1 disable"
                      aria-hidden="true"></i>
                    <span>{{'enterprise_customer_management.buttons.delete' | translate}}</span>
                  </button> -->
                  <!-- Trình ký xác nhận -->
                  <!-- <button mat-menu-item (click)="openDialogSignatureProcess(element.id, element)"
                    appTrackEvent="w.btn.hdtoilap.thaotackhac.trinh_ky_xac_nhan"
                    *ngIf="element.status === enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT && (!element.userApprove || element.userApprove == undefined)">
                    <mat-icon class="mr-1"
                      matTooltip="{{'enterprise_contract.buttons.signature_process' | translate}}">gesture
                    </mat-icon>
                    <mat-icon class="mr-1" *ngIf="warningContractQuantity">gesture</mat-icon>
                    <span>{{'enterprise_contract.buttons.signature_process' | translate}}</span>
                  </button> -->
                  <!-- Trình ký xác nhận lại -->
                  <!-- <button mat-menu-item (click)="openDialogReSignatureProcess(element.id, element)"
                    appTrackEvent="w.btn.hdtoilap.thaotackhac.trinh_ky_xac_nhan_lai"
                    *ngIf="element.status === enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT && element.userApprove">
                    <mat-icon class="mr-1"
                      matTooltip="{{'enterprise_contract.buttons.reassign_signature_process' | translate}}">
                      gesture
                    </mat-icon>
                    <mat-icon class="mr-1" *ngIf="warningContractQuantity">gesture</mat-icon>
                    <span>{{'enterprise_contract.buttons.reassign_signature_process' | translate}}</span>
                  </button> -->
                  <!-- Hủy trình ký xác nhận -->
                  <!-- <button mat-menu-item (click)="openDialogCancelSignatureProcess(element.id, element)"
                    appTrackEvent="w.btn.hdtoilap.thaotackhac.huy_trinh_ky_xac_nhan"
                    *ngIf="element.status === enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT && element.userApprove">
                    <mat-icon class="mr-1" style="color: #DE0D0D;"
                      matTooltip="{{'enterprise_contract.buttons.cancel_signature_process' | translate}}">
                      cancel_presentation
                    </mat-icon>
                    <mat-icon class="mr-1" *ngIf="warningContractQuantity">cancel_presentation</mat-icon>
                    <span>{{'enterprise_contract.buttons.cancel_signature_process' | translate}}</span>
                  </button> -->
                  <!-- Gửi link hợp đồng -->
                  <!-- <button mat-menu-item (click)="sendLinkContract(element.id, element)"
                    appTrackEvent="w.btn.hdtoilap.thaotackhac.gui_link_hd"
                    [disabled]="element.status === enumContractStatus.DRAFT || element.status === enumContractStatus.CANCELLED">
                    <mat-icon class="mr-1"
                      matTooltip="{{'enterprise_contract.buttons.send_link_contract' | translate}}">link
                    </mat-icon>
                    <mat-icon class="mr-1" *ngIf="warningContractQuantity">link</mat-icon>
                    <span>{{'enterprise_contract.buttons.send_link_contract' | translate}}</span>
                  </button> -->
                  <!-- Nhắc ký HĐ -->
                  <!-- <button mat-menu-item (click)="notifySignContract(element)"
                    appTrackEvent="w.btn.hdtoilap.thaotackhac.nhac_ky_hd"
                    [disabled]="element.status !== enumContractStatus.PROCESSING">
                    <i *ngIf="element.status == enumContractStatus.PROCESSING"
                      class="fa fa-bell-o fa-fw vt-cursor-pointer mr-2" aria-hidden="true"
                      style="color: #DE0D0D;font-size: 1rem;"
                      matTooltip="{{'enterprise_customer_management.buttons.notify_sign_contract' | translate}}">
                    </i>
                    <i *ngIf="element.status !== enumContractStatus.PROCESSING"
                      class="fa fa-bell-o fa-fw vt-cursor-pointer mr-2 disable" style="font-size: 1rem;"
                      aria-hidden="true"></i>
                    <span>{{'enterprise_customer_management.buttons.notify_sign_contract' | translate}}</span>
                  </button> -->

                  <!-- Chuyển tiếp HĐ -->
                  <!-- <button mat-menu-item (click)="forwardContract(element)"
                    appTrackEvent="w.btn.hdtoilap.thaotackhac.chuyentiephd"
                    [disabled]="element.status !== enumContractStatus.FINISHED">
                    <i *ngIf="element.status == enumContractStatus.FINISHED"
                      class="fa fa-paper-plane fa-fw vt-cursor-pointer mr-2" aria-hidden="true"
                      style="color: #07736C;font-size: 1rem;"
                      matTooltip="{{'enterprise_customer_management.buttons.forward_contract' | translate}}">
                    </i>
                    <i *ngIf="element.status !== enumContractStatus.FINISHED"
                      class="fa fa-paper-plane fa-fw vt-cursor-pointer mr-2 disable" style="font-size: 1rem;"
                      aria-hidden="true"></i>
                    <span>{{'enterprise_customer_management.buttons.forward_contract' | translate}}</span>
                  </button> -->

                  <!-- Hủy luồng -->
                  <button mat-menu-item (click)="cancelSignFlow(element.id, element)"
                    appTrackEvent="w.btn.hdtoilap.thaotackhac.huyluongky"
                    [disabled]="element.status !== contractUserStatus.PROCESSING && element.status !== contractUserStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT">
                    <mat-icon class="mr-1"
                      *ngIf="element.status == contractUserStatus.PROCESSING || element.status == contractUserStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT"
                      style="color: #DE0D0D;" matTooltip="{{'enterprise_contract.buttons.cancel_flow' | translate}}">
                      block
                    </mat-icon>
                    <mat-icon class="mr-1"
                      *ngIf="element.status !== contractUserStatus.PROCESSING && element.status !== contractUserStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT">
                      block
                    </mat-icon>
                    <span>{{'enterprise_contract.buttons.cancel_flow' | translate}}</span>
                  </button>

                  <!-- Chia sẻ hợp đồng cho đối tác -->
                  <!-- <button mat-menu-item (click)="shareContract(element)"
                    appTrackEvent="w.btn.hdtoilap.thaotackhac.chuyentiephd"
                    [disabled]="element.status !== enumContractStatus.FINISHED">
                    <mat-icon *ngIf="element.status === enumContractStatus.FINISHED" class="mr-1"
                      style="color: #07736C;font-size: 1rem;">share</mat-icon>
                    <mat-icon *ngIf="element.status !== enumContractStatus.FINISHED" class="mr-1"
                      style="font-size: 1rem;">share</mat-icon>
                    <span>{{'contract_share_partner.manage_share_with_partners' | translate}}</span>
                  </button> -->

                  <!-- Thanh lý hợp đồng văn bản -->
                  <!-- <button mat-menu-item (click)="terminationContract(element)"
                    *ngIf="element.formType !== 'CONTRACT_TERMINATION'"
                    [disabled]="element.status !== enumContractStatus.FINISHED || (element.status === enumContractStatus.FINISHED && (element.contractTerminationStatus === 4 || element.contractTerminationStatus === 2)) || !checkPermissionCreateContract()"> -->
                    <!-- <mat-icon *ngIf="element.status === enumContractStatus.FINISHED" class="mr-1" style="color: #07736C;font-size: 1rem;">contract_edit</mat-icon>
                    <mat-icon *ngIf="element.status !== enumContractStatus.FINISHED"  style="font-size: 1rem;">contract_edit</mat-icon> -->
                    <!-- <svg class="mr-1"
                      *ngIf="element.status === enumContractStatus.FINISHED && element.contractTerminationStatus !== 4 && element.contractTerminationStatus !== 2 && checkPermissionCreateContract()"
                      xmlns="http://www.w3.org/2000/svg" style="fill: #07736C;" height="24px" viewBox="0 -960 960 960"
                      width="24px" fill="#e3e3e3">
                      <path
                        d="M360-600v-80h360v80H360Zm0 120v-80h360v80H360Zm120 320H200h280Zm0 80H240q-50 0-85-35t-35-85v-120h120v-560h600v361q-20-2-40.5 1.5T760-505v-295H320v480h240l-80 80H200v40q0 17 11.5 28.5T240-160h240v80Zm80 0v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T903-300L683-80H560Zm300-263-37-37 37 37ZM620-140h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z" />
                    </svg>
                    <svg class="mr-1"
                      *ngIf="element.status !== enumContractStatus.FINISHED || (element.status === enumContractStatus.FINISHED && (element.contractTerminationStatus === 4 || element.contractTerminationStatus === 2)) || !checkPermissionCreateContract()"
                      xmlns="http://www.w3.org/2000/svg" style="fill: rgba(0, 0, 0, 0.38);" height="24px"
                      viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                      <path
                        d="M360-600v-80h360v80H360Zm0 120v-80h360v80H360Zm120 320H200h280Zm0 80H240q-50 0-85-35t-35-85v-120h120v-560h600v361q-20-2-40.5 1.5T760-505v-295H320v480h240l-80 80H200v40q0 17 11.5 28.5T240-160h240v80Zm80 0v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T903-300L683-80H560Zm300-263-37-37 37 37ZM620-140h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z" />
                    </svg>
                    <span>{{'contract_terminate.contract_termination' | translate}}</span>
                  </button> -->
                   <!-- Tạo mới phụ lục HĐ -->
                   <!-- <button mat-menu-item appTrackEvent="w.btn.hdtoilap.tao_moi_phu_luc"
                      *ngIf="!warningContractQuantity && !commonService.getIsLockedEnterprise() && checkPermissionCreateContract() && element.formType == 'CONTRACT'"
                      (click)="onAddDocument(element)" [disabled]="element.mohaStatus != '4'">
                      <mat-icon style="color: #DE0D0D;" class="mr-1" *ngIf="element.mohaStatus == 4"
                        matTooltip="{{'enterprise_contract.buttons.add_pl' | translate}}">add_circle
                      </mat-icon>
                      <mat-icon class="mr-1" *ngIf="element.mohaStatus != 4"
                        matTooltip="{{'enterprise_contract.buttons.add_pl' | translate}}">add_circle
                      </mat-icon>
                      <span>{{'enterprise_contract.buttons.add_pl' | translate}}</span>
                    </button> -->
                </mat-menu>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: false"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row"
                     [cdkDetailRowTpl]="tpl" (toggleChange)="onToggleChange($event,row)">
            </mat-row>
          </mat-table>
        </div>

        <ng-template #tpl let-element>
          <div class="mat-row detail-row" [@detailExpand] style="overflow: hidden">

          </div>
        </ng-template>

        <!-- Pagination -->
        <app-pagination [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)">
        </app-pagination>
      </mat-expansion-panel>
    </mat-accordion>

  </mat-card-content>
</mat-card>
